import { FormHelperText, Stack } from '@mui/material';
import { FormCheckbox } from 'components/views/forms/form-checkbox';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FieldPath } from 'react-hook-form/dist/types/path/eager';
import { CreateTcrCampaignInput } from 'types/apollo/globalTypes';
import { PropertyOfType } from 'utils/typings';
import { helperTexts } from './tcr-constants';

const CheckboxWithHelperText: FC<{
  name: FieldPath<CreateTcrCampaignInput> & PropertyOfType<CreateTcrCampaignInput, boolean>;
  label: string;
  disabled?: boolean;
}> = (props) => {
  const form = useFormContext<CreateTcrCampaignInput>();
  return (
    <Stack direction="column" sx={{ padding: 1 }}>
      <FormCheckbox form={form} name={props.name} label={props.label} disabled={props.disabled} />
      <FormHelperText>{helperTexts[props.name]}</FormHelperText>
    </Stack>
  );
};

export const TcrCheckboxGrid: FC<{ disabled: boolean }> = ({ disabled }) => (
  <Stack direction="row">
    <Stack direction="column" width="50%">
      <CheckboxWithHelperText name="subscriberOptin" label="Subscriber Opt-in" disabled />
      <CheckboxWithHelperText name="subscriberOptout" label="Subscriber Opt-out" disabled />
      <CheckboxWithHelperText name="subscriberHelp" label="Subscriber Help" disabled />
      <CheckboxWithHelperText name="numberPool" label="Number pooling" disabled={disabled} />
      <CheckboxWithHelperText name="directLending" label="Direct Lending" disabled={disabled} />
    </Stack>
    <Stack direction="column" width="50%">
      <CheckboxWithHelperText name="embeddedLink" label="Contains links" disabled={disabled} />
      <CheckboxWithHelperText
        name="embeddedPhone"
        label="Contains phone number"
        disabled={disabled}
      />
      <CheckboxWithHelperText name="ageGated" label="Age Gated" disabled={disabled} />
      <CheckboxWithHelperText
        name="affiliateMarketing"
        label="Affiliate Marketing"
        disabled={disabled}
      />
    </Stack>
  </Stack>
);
